import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('TermsDialogController', TermsDialogController);

    function TermsDialogController($scope, ngDialog, AuthFactory, toastr) {
        var vm = this;

        init();

        function init() {
            vm.filePath = $scope.ngDialogData.filePath;
            vm.accept = accept;
        }

        function accept() {
            AuthFactory.tosAccept({ tos: true }).then(function () {
                toastr.success(
                    'Dziękujemy. Możesz dalej korzystać z iWykonawca.pl'
                );
                ngDialog.close();
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/agreements_dialogs/terms_dialog/terms_dialog.controller.ts